import React, { useRef } from 'react';
import { css } from 'linaria';
import { LinkWithGAPromoClick, Section, SectionSubTitle } from 'common/components';
import { usePromoViewEvent } from 'common/hooks';
import { lowerBoundsBreakpoints, strictBreakpoints } from 'common/styles/breakpoints';
import { createElementKey } from 'utils';

type SeasonStartBannersProps = {
  bannerList: {
    link: {
      href: string;
      title: string;
    };
    img: {
      alt: string;
      srcD: string;
      srcT: string;
      src: string;
    }
  }[];
  elementBlock: string;
  title: string;
  type: 'ggr' | 'sale';
};

const seasonStartBanners = css`
  display: flex;
  gap: 32px;
  flex-wrap: wrap;

  @media (--only-mobile) {
    flex-direction: column;
  }
`;

const seasonStartBanner = css`
  @media (--only-largeDesktop) {
    width: 574px;
    height: 225px;
  }

  @media (--only-desktop) {
    width: 454px;
    height: 180px;
  }

  @media (--only-tablet) {
    width: 314px;
    height: 125px;
  }

  @media (--only-mobile) {
    width: 100%;
    height: 100%;
  }

  img {
    width: 100%;
  }
`;

export const SeasonStartBanners: React.FC<SeasonStartBannersProps> = ({ bannerList, elementBlock, title, type }) => {
  const refs = useRef<HTMLAnchorElement[]>([]);
  const promotions = bannerList.map((banner, index: number) => ({
    name: `${elementBlock}_${type}`,
    creative: banner.link.title,
    position: (index + 1).toString(),
  }));

  usePromoViewEvent(refs, elementBlock, promotions);

  return (
    <Section>
      <SectionSubTitle margin="m">
        {title}
      </SectionSubTitle>

      <div className={seasonStartBanners}>
        {bannerList.map(({ link, img }, index) => (
          <LinkWithGAPromoClick
            bannerRefs={refs}
            className={seasonStartBanner}
            position={index}
            promotion={promotions[index]}
            elementBlock={elementBlock}
            key={createElementKey('ready-made-solution-card', index)}
            href={link.href}
            title={link.title}
          >
            <picture>
              <source srcSet={img.srcD} media={lowerBoundsBreakpoints['--from-desktop']} />
              <source srcSet={img.srcT} media={strictBreakpoints['--only-tablet']} />
              <img alt={img.alt} src={img.src} />
            </picture>
          </LinkWithGAPromoClick>
        ))}
      </div>
    </Section>
  )
};
